import { render } from "./QuoteSlider.vue?vue&type=template&id=cbce57c0"
import script from "./QuoteSlider.vue?vue&type=script&lang=js"
export * from "./QuoteSlider.vue?vue&type=script&lang=js"

import "./QuoteSlider.vue?vue&type=style&index=0&id=cbce57c0&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__